module.exports = __webpack_public_path__ + "img/icon_delete.95073926.svg";